import { Fragment, ReactElement, useState } from "react";
import "./styles.scss";
import { DrawerTypes } from "../../shared/types";
import type { DevShellDeviceType } from "../../shared/deviceType";
import { DeviceTypeToggle } from "../DeviceTypeToggle";

interface IMenu {
  onMenuItemClick: (menuItemType: DrawerTypes | null) => void;
  onAudioPlayerToggle: () => void;
  minimalShell?: boolean;
  showSpotlightAudio?: boolean;
  spotlightAudioDisabled?: boolean;
  hideAudioSettings?: boolean;
  showDeviceTypeToggle?: boolean;
  deviceType?: DevShellDeviceType;
  onDeviceTypeChange?: (deviceType: DevShellDeviceType) => void;
}

export const Menu = ({
  onMenuItemClick,
  onAudioPlayerToggle,
  minimalShell = false,
  showSpotlightAudio = false,
  spotlightAudioDisabled = false,
  hideAudioSettings = false,
  showDeviceTypeToggle = false,
  deviceType = "web",
  onDeviceTypeChange,
}: IMenu): ReactElement => {
  const [showMenu, setShowMenu] = useState(true);

  const toggleMenu = (): void => {
    showMenu && onMenuItemClick(null); // If menu is open then sending null means close all the drawers.
    setShowMenu(!showMenu);
  };

  return (
    <Fragment>
      {showMenu ? (
        <div className="menu">
          <div className="menu-items">
            <button
              className="menu-item toc"
              aria-label="Table of Contents"
              onClick={(): void => onMenuItemClick(DrawerTypes.TOC)}
            ></button>
            {/* <button className="menu-item navigation" aria-label="Navigation"></button> */}
            <button
              className="menu-item search"
              aria-label="Search"
              onClick={() => onMenuItemClick(DrawerTypes.SEARCH)}
            ></button>
            <hr />
            {!minimalShell && !hideAudioSettings && (
              <button
                className="menu-item audio-settings"
                aria-label="Audio settings"
                onClick={() => onMenuItemClick(DrawerTypes.AUDIOBOOK)}
              ></button>
            )}
            <button
              className="menu-item notebook"
              aria-label="Notebook"
              onClick={() => onMenuItemClick(DrawerTypes.NOTEBOOK)}
            ></button>
            <button
              className="menu-item study"
              aria-label="Study"
              onClick={() => onMenuItemClick(DrawerTypes.FLASHCARD)}
            ></button>

            {/* {!minimalShell && ( */}
            <>
              <hr />
              <button
                className="menu-item settings"
                aria-label="Settings"
                onClick={(): void => onMenuItemClick(DrawerTypes.SETTINGS)}
              ></button>
              {showSpotlightAudio && (
                <button
                  className={`menu-item spotlight-audio${
                    spotlightAudioDisabled ? " disabled" : ""
                  }`}
                  aria-label="Spotlight audio player"
                  disabled={spotlightAudioDisabled}
                  onClick={onAudioPlayerToggle}
                ></button>
              )}
            </>
            {/* )} */}

            {/* <button className="menu-item close" aria-label="Close" onClick={toggleMenu}></button> */}
          </div>
          {showDeviceTypeToggle && !minimalShell && onDeviceTypeChange && (
            <DeviceTypeToggle deviceType={deviceType} onDeviceTypeChange={onDeviceTypeChange} />
          )}
        </div>
      ) : (
        <button className="menu-toggle" aria-label="Open Menu" onClick={toggleMenu}></button>
      )}
    </Fragment>
  );
};
